export default function Marster() {
  return (
    <div>
      <h2>尚未開放</h2>
    </div>
  )
}
